import { Progress, Typography } from 'antd';
import './CommandComponent.scss';

const { Title } = Typography;

interface CommandComponentProps {
  title: string;
  speed: number;
}

const CommandComponent = ({ title, speed }: CommandComponentProps) => {
  return (
    <div className="CommandComponent">
      <Title level={5} className={'CommandComponent__title'}>
        Velocidad {title}
      </Title>
      <Progress percent={speed} strokeWidth={20} />
    </div>
  );
};

export default CommandComponent;
